import React, { useState } from "react";
import { Modal, TextInput, Button, Group } from "@mantine/core";
import config from "config";
import { toast } from "react-toastify";

const FilterRenameModal = ({
  isOpen,
  onClose,
  filterId,
  onRenameSuccess,
  getFilters,
}) => {
  const [newName, setNewName] = useState("");
  const api = config.backOffice.apiName;
  const handleRename = async () => {
    if (!newName.trim()) {
      toast.error("Veuillez entrer un nouveau nom pour le filtre.");
      return;
    }

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/change_filter_name`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "auth_token_" + api
            )}`, // Remplacez par votre gestion de token
          },
          body: JSON.stringify({ id: filterId.value, name: newName }),
        }
      );

      if (response.ok) {
        onRenameSuccess();

        onClose();
      } else {
        toast.error("Erreur lors de la mise à jour du nom du filtre.");
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    }
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title="Renommer le filtre"
      centered
    >
      <TextInput
        label="Nouveau nom du filtre"
        placeholder="Entrez le nouveau nom"
        value={newName}
        onChange={(event) => setNewName(event.currentTarget.value)}
        required
      />
      <Group position="right" mt="md">
        <Button variant="default" onClick={onClose}>
          Annuler
        </Button>
        <Button onClick={handleRename}>Renommer</Button>
      </Group>
    </Modal>
  );
};

export default FilterRenameModal;
